import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Dropdown, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from "react-i18next";

//import api
import { transferCurrency } from "../../action/walletAction";

//import lib
import isEmpty from "../../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf"
import { toastAlert, textCopy } from "../../utils/toast";

//import validation
import { Validation } from "./validation"

const initialFormValue = {
    fromCurrencyId: "",
    toCurrencyId: "",
    amount: 0
}

const ExchangeModal = (props) => {

    //props
    const { isShow, record, onHide } = props

    //redux
    const currency = useSelector((state) => state.currency);
    const walletData = useSelector((state) => state.wallet);
    const priceConversion = useSelector((state) => state.priceconversion);
    const [firstCurrency, setFirstCurrency] = useState({})
    const [secondCurrency, setSecondCurrency] = useState({})

   const [selectedOption, setSelectedOption] = useState({
    value: "USD",
    imageSrc: require("../../assets/images/crypto/usd.png"),
  });
    //hooks
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()

    //state
    const [options, setOption] = useState([])
    const [loader, setLoader] = useState(false)
    const [errors, setErrors] = useState({})
    const [formValue, setFormValue] = useState(initialFormValue)
    const { fromCurrencyId, toCurrencyId, amount } = formValue;
    const [convertAmount, setConAmount] = useState(0)
    const [toCurrency, settoCurrency] = useState("")
    const [currencyOption, setCurrencyOption] = useState([])

    //function
    const handleClick = () => {
        let formData = { ...formValue, ...{ ["amount"]: toFixedDown(record?.balance, 8) } };
        setFormValue(formData);
    }

    const hanldeClose = () => {
        onHide()
        setErrors({})
        setFormValue(initialFormValue)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        let formData = { ...formValue, ...{ [name]: (value) } }
        setFormValue(formData);
        if (!isEmpty(errors)) {
            setErrors({});
        }
    }

    const handleAmount = (e) => {
        const { name, value } = e.target;
        if (/[^0-9.]/.test(value)) return;
        let formData = { ...formValue, ...{ [name]: toFixedDown(value, 8) } }
        setFormValue(formData);
        if (!isEmpty(errors)) {
            setErrors({});
        }
    }

    const fetchData = () => {
        let array = []        
        walletData && walletData.length > 0 && walletData.map((item, key) => {
            let findata = currency && currency.find((el) => el._id == item._id);
           if(findata){
           if(item?._id.toString() === findata?._id.toString()){                
                array.push({
                value: findata?._id,
                label: findata?.currencySymbol,
                image: findata?.image,
                balance:truncateDecimals(item?.balance,findata?.decimals)
            })
            }
           }
         
            
        })
        setOption(array)
        const firstCurrencySelect = array.find ((option) => option.label === "USD" || option.label === "USDT");
        setFirstCurrency(firstCurrencySelect)
         const secondCurrencySelect = array.find ((option) => option.label === "BTC" || option.label === "ETH");
        setSecondCurrency(secondCurrencySelect)
    }
  const handleFirstCurrency = (eventKey) => {
    const firstCurrencySelect = options.find(
      (option) => option.value === eventKey
    );
    setFirstCurrency(firstCurrencySelect);
    
  };
const handlesecondCurrency = (eventKey) => {
    const secondCurrencySelect = options.find(
      (option) => option.value === eventKey
    );
    setSecondCurrency(secondCurrencySelect);
  };
    const handleAsset = () => {
        let fromCurrency = firstCurrency?.label == 'USDT' ? "USD" : firstCurrency?.label
        let toCurrency = currency && currency.find((el) => el._id.toString() == secondCurrency?.value);
        let convertSymbol = toCurrency?.currencySymbol == 'USDT' ? "USD" : toCurrency?.currencySymbol
        settoCurrency(toCurrency?.currencySymbol)
        let priceCNV;
        console.log("...fromCurrency",fromCurrency, "toCurrency", convertSymbol);
        if(fromCurrency==="USD" && convertSymbol==="USD"){
          fromCurrency="USDT";
          convertSymbol="USD"
        }
        if (priceConversion && priceConversion.length > 0) {
            priceCNV = priceConversion.find((el) => el.baseSymbol == fromCurrency && el.convertSymbol == convertSymbol || el.baseSymbol == convertSymbol && el.convertSymbol == fromCurrency);
        }
        // console.log(priceCNV, 'price/CNV')
        // console.log(convertSymbol, 'convertSymbol', record?.coin)
        let conPrice = convertSymbol != priceCNV?.convertSymbol ? (1 / priceCNV?.convertPrice) : priceCNV?.convertPrice
        // console.log(conPrice, 'conPrice')
        setConAmount(conPrice * amount)
    }


    const handleSubmit = async () => {
        try {
            setLoader(true)
            if(firstCurrency?.value==secondCurrency?.value){
                toastAlert("error", t("CURRENCY_NOT_MATCH"), "login");
                setLoader(false);
                return
            }
            let reqData = {
                fromCurrencyId: firstCurrency?.value,
                toCurrencyId: secondCurrency?.value,
                amount: amount
            }
            let validationError = Validation(reqData);
            if (!isEmpty(validationError)) {
                setErrors(validationError);
              toastAlert("error", t(validationError?.message ), "login");
                setLoader(false);
                return;
            }
            const { status, error, loading, message } = await transferCurrency(reqData, dispatch)
            setLoader(loading)
            if (status == 'success') {
                setLoader(false)
                // hanldeClose()
                setFormValue({...formValue,amount:0})
                setConAmount(0)
                toastAlert("success", t(message), "login");
            } else {
                setLoader(false)
                if (error) {
                    setErrors(error)
                }
                toastAlert("error", t(message), "login");
            }
        } catch (err) {
            setLoader(false)
            console.log(err, 'error')
        }
    }


    useEffect(() => {
            fetchData()
        
    }, [walletData, isShow, currency, priceConversion])

    useEffect(() => {
        handleAsset()
    }, [amount, secondCurrency])


    // console.log(record, 'record')
    let Balance = record?.balance

    return (
       
          <form className="exchange_form">
                <div className="mb-3">
                  <p className="mb-2 text-end">
                    {t("AVAILABLE_BALANCE")}:  {firstCurrency?.balance?firstCurrency?.balance:0}
                  </p>
                  <div className="exchange_input_grp">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="fw-semibold">{t("YOU_SEND")}</label>
                      <input
                        type="text"
                        name="amount"
                        onChange={handleAmount}
                        value={amount}
                        className="form-control fw-bold fs-5"
                        placeholder="0.00"
                      />
                      
                    </div>
                    <Dropdown
                      onSelect={handleFirstCurrency}    
                      className="image_dropdown_wrapper"
                    >
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="image_dropdown"
                      >
                        <Image
                          src={firstCurrency?.image}
                          alt={firstCurrency?.label}
                          width={38}
                          height={38}
                        />
                        {firstCurrency?.label}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {options
                          .filter(
                            (option) => option.label !== firstCurrency?.label 
                          ) // exclude current
                          .map((option) => (
                            <Dropdown.Item
                              key={option.value}
                              eventKey={option.value}
                            >
                              <Image
                                src={option.image}
                                alt={option.label}
                                width={38}
                                height={38}
                              />{" "}
                              {option.label}
                            </Dropdown.Item>
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <Image
                    src={require("../../assets/images/exchange_icon.png")}
                    alt="Exchange Arrow"
                    className="img-fluid"
                    width={50}
                  />
                </div>
                <div className="mb-3">
                  <div className="exchange_input_grp">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="fw-semibold">{t("YOU_GET")}</label>
                      <div class="px-2 py-2 fw-bold fs-5 w-75 text-end">≈ {truncateDecimals(convertAmount ? convertAmount : 0, 4)}</div>
                    </div>
                    <Dropdown
                     onSelect={handlesecondCurrency}
                      className="image_dropdown_wrapper"
                    >
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="image_dropdown"
                      >
                        <Image
                          src={secondCurrency?.image}
                          alt={secondCurrency?.value}
                          width={38}
                          height={38}
                        />
                        {secondCurrency?.label}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {options
                          .filter(
                            (option) => option.label !== secondCurrency?.label && option.label !== firstCurrency?.label
                          ) // exclude current
                          .map((option) => (
                            <Dropdown.Item
                              key={option.value}
                              eventKey={option.value}
                            >
                              <Image
                                src={option.image}
                                alt={option.value}
                                width={38}
                                height={38}
                              />{" "}
                              {option.label}
                            </Dropdown.Item>
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>
                
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-center gap-3 mt-5">
                  <button
                    type="button"
                    className="primary_btn market_btn w-100"
                    onClick={()=>{setConAmount(0);setFormValue({...formValue,amount:0})}}
                  >
                    {t("CANCEL")}
                  </button>
                  <button
                    type="button"
                    className="primary_btn primary_btn_with_bg primary_btn_transform xs_btn w-100"
                     onClick={handleSubmit}
                  >
                    {loader && <i class="fas fa-spinner fa-spin"></i>}
                    {t("Exchange")}
                  </button>
                </div>
              </form>
    )
}


export default ExchangeModal;